<template>
  <div class="payment-drawer-wrapper" :class="{ show: showDrawer === true }">
    <a class="close-btn" @click="closeDrawer">X</a>
    <HighlightContainerCheckout
      title="Efetue o pagamento para finalizar a compensação ambiental de embalagens da sua empresa."
      even
      class="pa-0"
    >
      <v-container>
        <v-row>
          <v-col cols="12">
            <h3>Pagamento</h3>
            <h5>Selecione a forma de pagamento</h5>
          </v-col>
          <v-col cols="12">
            <v-radio-group v-model="formFields.paymentMethod" row>
              <v-radio value="card" color="#003036">
                <template v-slot:label>
                  <v-icon>{{ mdiCreditCardChipOutline }}</v-icon> Crédito
                </template>
              </v-radio>
              <v-radio value="bank_slip" color="#003036">
                <template v-slot:label>
                  <v-icon>{{ mdiBarcode }}</v-icon> Boleto
                </template>
              </v-radio>
            </v-radio-group>
          </v-col>
          <v-form v-model="isFormValid">
            <v-col cols="12">
              <div class="payment-type-card-form">
                <v-row>
                  <v-col cols="12" md="5">
                    <label for="payment-form-cnpj" class="v-label"
                      >CNPJ *</label
                    >
                    <v-text-field
                      id="payment-form-cnpj"
                      v-model="formFields.cnpj"
                      v-mask="['##.###.###/####-##']"
                      :rules="rules.cnpj"
                      placeholder="99.999.999/9999-99"
                      required
                      solo
                      type="tel"
                      @change="searchCNPJ(formFields.cnpj)"
                    />
                  </v-col>
                  <v-col cols="12" md="5" offset-md="1">
                    <label for="payment-form-organization_name" class="v-label"
                      >Razão social *</label
                    >
                    <v-text-field
                      id="payment-form-organization_name"
                      v-model="formFields.organization_name"
                      :rules="rules.organization_name"
                      placeholder="Informe a razão social"
                      required
                      solo
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <label for="payment-form-contact_name" class="v-label"
                      >Nome completo do representante legal *</label
                    >
                    <v-text-field
                      id="payment-form-contact_name"
                      v-model="formFields.contact_name"
                      :rules="rules.contact_name"
                      required
                      placeholder="Informe o nome do representante"
                      solo
                    />
                  </v-col>
                  <v-col cols="12" md="5" offset-md="1">
                    <label for="payment-form-contact_cpf" class="v-label"
                      >CPF do representante legal *</label
                    >
                    <v-text-field
                      id="payment-form-contact_cpf"
                      v-model="formFields.contact_cpf"
                      v-mask="'###.###.###-##'"
                      :rules="rules.contact_cpf"
                      required
                      validate-on-blur
                      placeholder="999.999.999-99"
                      solo
                      type="tel"
                    />
                  </v-col>

                  <v-col cols="12" md="5">
                    <label for="address_zipcode" class="v-label">CEP:</label>
                    <v-text-field
                      id="address_zipcode"
                      v-model="formFields.address_zipcode"
                      v-mask="'#####-###'"
                      :rules="rules.contact_cep"
                      required
                      validate-on-blur
                      placeholder="00000-000"
                      solo
                    />
                  </v-col>

                  <v-col cols="12" md="5" offset-md="1">
                    <label for="address_name" class="v-label">Rua:</label>
                    <v-text-field
                      id="address_name"
                      v-model="formFields.address_street_name"
                      :rules="rules.address_street_name"
                      required
                      validate-on-blur
                      placeholder=""
                      solo
                    />
                  </v-col>

                  <v-col cols="12" md="5">
                    <label for="address_number" class="v-label">Número:</label>
                    <v-text-field
                      id="address_number"
                      v-model="formFields.address_street_number"
                      :rules="rules.address_number"
                      required
                      validate-on-blur
                      solo
                    />
                  </v-col>

                  <v-col cols="12" md="5" offset-md="1">
                    <label for="address_additional_info" class="v-label"
                      >Complemento:</label
                    >
                    <v-text-field
                      id="address_additional_info"
                      v-model="formFields.address_additional_info"
                      :rules="rules.address_additional_info"
                      validate-on-blur
                      placeholder=""
                      solo
                    />
                  </v-col>

                  <v-col
                    v-if="formFields.paymentMethod === 'card'"
                    cols="12"
                    md="5"
                  >
                    <label for="payment-form-name_on_card" class="v-label"
                      >Nome impresso no cartão *</label
                    >
                    <v-text-field
                      id="payment-form-name_on_card"
                      v-model="formFields.name_on_card"
                      :rules="rules.name_rules"
                      placeholder="Informe o nome no cartão"
                      required
                      solo
                    />
                  </v-col>
                  <v-col
                    v-if="formFields.paymentMethod === 'card'"
                    cols="12"
                    md="5"
                    offset-md="1"
                  >
                    <label for="payment-form-cardnumber" class="v-label"
                      >Número do cartão *</label
                    >
                    <v-text-field
                      id="payment-form-cardnumber"
                      v-model="formFields.cardnumber"
                      v-mask="'#### #### #### ####'"
                      :rules="rules.cardnumber"
                      placeholder="0000 0000 0000 0000"
                      required
                      solo
                      type="tel"
                    />
                  </v-col>
                  <v-col
                    v-if="formFields.paymentMethod === 'card'"
                    cols="12"
                    md="5"
                  >
                    <label for="payment-form-expireDate" class="v-label"
                      >Data da expiração *</label
                    >
                    <v-text-field
                      id="payment-form-expireDate"
                      v-model="formFields.expireDate"
                      v-mask="'##/####'"
                      :rules="rules.expireDate"
                      placeholder="MM/AAAA"
                      required
                      solo
                      type="tel"
                    />
                  </v-col>
                  <v-col
                    v-if="formFields.paymentMethod === 'card'"
                    cols="12"
                    md="5"
                    offset-md="1"
                  >
                    <label for="payment-form-cardcvv" class="v-label"
                      >CVV *</label
                    >
                    <v-text-field
                      id="payment-form-cardcvv"
                      v-model="formFields.cardcvv"
                      v-mask="'####'"
                      :rules="rules.cardcvv"
                      placeholder="000"
                      required
                      solo
                      type="tel"
                    />
                  </v-col>
                  <v-col cols="12" md="5">
                    <label for="payment-form-promocode" class="v-label"
                      >Cupom de desconto</label
                    >
                    <v-text-field
                      id="payment-form-promocode"
                      v-model="formFields.promocode"
                      placeholder="Insira o cupom"
                      solo
                    />
                  </v-col>
                  <v-col
                    v-if="formFields.paymentMethod === 'card'"
                    cols="12"
                    md="5"
                    offset-md="1"
                  >
                    <label for="payment-form-installment" class="v-label"
                      >Parcelamento *</label
                    >
                    <v-select
                      id="payment-form-installment"
                      v-model="formFields.installment"
                      item-text="text"
                      item-value="value"
                      :rules="rules.installment"
                      :items="installments"
                      required
                      solo
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="5">
                    <v-select
                      v-model="formFields.organization_company_size_guid"
                      :items="organizationSizes"
                      item-text="organization_description"
                      item-value="guid"
                      :rules="rules.organization_company_size_rules"
                      required
                      label="Porte"
                      solo
                    />
                  </v-col>
                  <v-col v-if="containMS()" cols="12" md="5" offset-md="1">
                    <v-autocomplete
                      v-model="formFields.affiliated_to"
                      :rules="rules.affiliated_to"
                      :items="associationList"
                      item-text="name"
                      item-value="guid"
                      no-data-text="Associação não encontrada"
                      label="Associação"
                      solo
                      required
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      outlined
                      large
                      class="cancel-btn"
                      @click="closeDrawer"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      v-if="formFields.paymentMethod === 'card'"
                      :disabled="!isFormValid"
                      outlined
                      large
                      @click="postPaymentMethod"
                    >
                      Pagar com cartão
                    </v-btn>
                    <v-btn
                      v-if="formFields.paymentMethod !== 'card'"
                      :disabled="!isFormValid"
                      :href="orderStatus.subscription.latest_invoice_url"
                      target="_blank"
                      outlined
                      large
                      @click="postPaymentMethod"
                    >
                      Visualizar boleto
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>
          </v-form>
        </v-row>
      </v-container>
    </HighlightContainerCheckout>
    <v-dialog v-model="dialogShow" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"> Erro </v-card-title>
        <v-card-text> Falha ao processar pagamento </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded text @click="dialogShow = false"> OK </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import CHECKOUT_CONST from '@/constants/Checkout';
import CheckoutProvider from '@/providers/CheckoutProvider';
import UtilsProvider from '@/providers/UtilsProvider';
import { promisify } from 'util';
import { mask } from 'vue-the-mask';
import { format, getYear } from 'date-fns';
import { mdiCreditCardChipOutline, mdiBarcode } from '@mdi/js';

export default {
  name: 'PaymentDrawer',
  components: {
    HighlightContainerCheckout: () =>
      import('@/components/HighlightContainerCheckout.vue'),
  },
  directives: { mask },
  props: {
    showDrawer: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isFormValid: false,
      dialogShow: false,
      mdiCreditCardChipOutline,
      mdiBarcode,
      formFields: {
        cnpj: '',
        organization_name: '',
        contact_name: '',
        contact_cpf: '',
        promocode: '',
        modalCoupom: false,
        paymentMethod: 'card', // bank_slip or card
        cardnumber: '',
        name_on_card: '',
        cardcvv: '',
        expireDate: '',
        installment: 1,
        organization_company_size_guid: '',
        affiliated_to: '',
        organization_guid: null,
        address_zipcode: '',
        address_street_name: '',
        address_street_number: '',
        address_additional_info: '',
        address_city: '',
        address_state: '',
      },
      installments: [
        { text: '1x sem juros', value: 1 },
        { text: '2x sem juros', value: 2 },
        { text: '3x sem juros', value: 3 },
        { text: '4x sem juros', value: 4 },
        { text: '5x sem juros', value: 5 },
        { text: '6x sem juros', value: 6 },
        { text: '7x sem juros', value: 7 },
        { text: '8x sem juros', value: 8 },
        { text: '9x sem juros', value: 9 },
        { text: '10x sem juros', value: 10 },
        { text: '11x sem juros', value: 11 },
        { text: '12x sem juros', value: 12 },
      ],
      organizationSizes: [],
      associationList: [],
      selectedStates: [],
      planoEscolhido: null,
    };
  },
  computed: {
    ...mapState(['checkout']),
    rules() {
      return {
        promocode: [
          v => !!v || 'Campo Obrigatório',
          v =>
            !this.getPlanData.valid_coupon &&
            String(v).toLowerCase() !==
              String(this.getPlanData.coupon_code).toLowerCase()
              ? true
              : 'Cupom Inválido',
        ],
        affiliated_to: [v => !!v || 'Associação é um campo obrigatório'],
        name_rules: [
          v => !!v || 'Campo obrigatório',
          v =>
            (v && v.length >= 3) || 'Nome deve conter no mínimo 3 caracteres',
          v =>
            (v && v.length <= 255) ||
            'Nome deve conter no máximo 255 caracteres',
        ],
        cardnumber: [
          v =>
            window.Iugu.utils.validateCreditCardNumber(v) || 'Cartão Inválido',
        ],
        cardcvv: [
          v =>
            window.Iugu.utils.validateCVV(
              v,
              window.Iugu.utils.getBrandByCreditCardNumber(
                this.formFields.cardnumber,
              ),
            ) || 'CVV Inválido',
        ],
        expireDate: [
          v =>
            (window.Iugu.utils.validateExpirationString(v) && v.length === 7) ||
            'Data Inválida',
        ],
        cnpj: [
          v => !!v || 'CNPJ é um campo obrigatório',
          v => !v || UtilsProvider.validateCNPJ(v) || 'CNPJ inválido!',
        ],
        organization_name: [
          v => !!v || 'Razão social é um campo obrigatório',
          v =>
            (v && v.length >= 3) ||
            'Razão social deve conter no mínimo 3 caracteres',
          v =>
            (v && v.length <= 255) ||
            'Razão social deve conter no máximo 255 caracteres',
        ],
        contact_name: [
          v => !!v || 'Nome é um campo obrigatório',
          v =>
            (v && v.length >= 3) || 'Nome deve conter no mínimo 3 caracteres',
          v =>
            (v && v.length <= 255) ||
            'Nome deve conter no máximo 255 caracteres',
        ],
        contact_cpf: [
          v => !!v || 'CPF é um campo obrigatório',
          v => !v || UtilsProvider.validateCPF(v) || 'CPF inválido!',
        ],
        contact_cep: [v => !!v || 'Cep é um campo obrigatório'],
        address_street_name: [v => !!v || 'Rua é um campo obrigatório'],
        address_number: [v => !!v || 'Número é um campo obrigatório'],
        installment: [v => !!v || 'Campo obrigatório'],
        organization_company_size_rules: [
          v => !!v || 'Selecione uma das opções',
        ],
      };
    },
    getPlanData() {
      return this.$store.getters.planData;
    },
    orderStatus() {
      const orderStatus = this.$store.getters.getOrderStatus;

      if (orderStatus != null && orderStatus.subscription.start_date) {
        orderStatus.subscription.start_dateFormatted = format(
          new Date(orderStatus.subscription.start_date),
          'dd/MM/yyyy',
        );
      }

      return this.$store.getters.getOrderStatus;
    },
    recurrence() {
      return this.orderStatus.subscription.payment_method ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
        ? 'Anual'
        : 'Mensal';
    },
    payment_method() {
      return this.orderStatus.subscription.payment_method ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
        ? 'Boleto Bancário'
        : 'Cartão de Crédito';
    },
    showBankSlip() {
      return (
        this.orderStatus.subscription.payment_method ===
        CHECKOUT_CONST.PAYMENT.BANK_SLIP
      );
    },
  },
  watch: {
    showDrawer() {
      this.planoEscolhido = this.$store.getters.planData.prices[
        this.$store.getters.liabilityPercentage
      ];
      if (this.showDrawer === true) {
        this.selectedStates = this.$store.getters.getStates;
        this.associationList = this.$store.getters.getAssociationList;
        document.querySelector('html').style.overflow = 'hidden';
      } else {
        document.querySelector('html').style.overflow = 'auto';
      }
    },
  },
  beforeMount() {
    this.getOrganizationSizes();
  },
  methods: {
    async postNewClientForm() {
      try {
        const leadForm = this.$store.getters.getLeadForm;

        const client = {
          organization_name: this.formFields.organization_name,
          organization_nickname: this.formFields.organization_name,
          organization_cnpj: this.formFields.cnpj.replace(/[^\d]+/g, ''),
          organization_industry: '',
          organization_size_guid: this.formFields
            .organization_company_size_guid,
          contact_name: leadForm.lead_contact_name,
          contact_job_title: '',
          contact_phone: leadForm.lead_contact_mobile_phone,
          contact_email: leadForm.lead_contact_email,
          contact_cpf: this.formFields.contact_cpf.replace(/[^\d]+/g, ''),
          company_branches: [],
          affiliated_to: this.formFields.affiliated_to,
          address_zipcode: this.formFields.address_zipcode,
          address_street_name: this.formFields.address_street_name,
          address_street_number: this.formFields.address_street_number,
          address_city: leadForm.lead_contact_city,
          address_state: leadForm.lead_contact_state,
          address_additional_info: this.formFields.address_additional_info,
          coverage_area_code: this.selectedStates.map(value =>
            value.value.toString(),
          ),
          guid: this.formFields.organization_guid
            ? this.formFields.organization_guid
            : '',
          referrer: '',
        };

        // Campos para MS
        // if (this.containMS()) {
        //   client.company_branches = this.getCompanyBranches;
        //   client.affiliated_to = this.companyForm.affiliated_to;
        // }

        const response = await CheckoutProvider.postNewClient(client);

        response.data.valid = response.data.valid ? response.data.valid : true;

        response.data.organization.federal_registration = response.data
          .organization.federal_registration
          ? response.data.organization.federal_registration
          : client.organization_cnpj;

        response.data.organization.name = response.data.organization.name
          ? response.data.organization.name
          : client.organization_name;

        this.$store.commit('organization', response.data);
        this.formFields.organization_guid = response.data.organization.guid;
        this.$analytics('organization_form', 'success');
        // this.handleChangeStep(1);
        return true;
      } catch (err) {
        console.error(err);
        this.signupError = true;
        return false;
      }
    },
    containMS() {
      return this.$store.getters.containMS;
    },
    encurtaNome(state) {
      return state.substring(3);
    },
    // eslint-disable-next-line consistent-return
    async postPaymentMethod() {
      try {
        const response = await this.postNewClientForm();
        if (!response) {
          return false;
        }
        const leadForm = this.$store.getters.getLeadForm;
        const nomes = this.formFields.name_on_card.split(' ');
        const [primeiroNome] = nomes;
        this.formFields.firstName = primeiroNome;
        nomes.splice(0, 1);

        this.formFields.lastName = nomes.join(' ');

        const pricingItems = this.checkout.materials.map(material => ({
          material_name: material.material_name,
          material_percent: material.value,
        }));

        console.log(this.$store.getters.planData.plan_id);
        console.log(
          this.formFields.paymentMethod === 'bank_slip'
            ? `${this.$store.getters.planData.plan_id}-yearly`
            : this.$store.getters.planData.plan_id,
        );

        let request = {
          promocode: this.formFields.promocode,
          liability_percentage: this.planoEscolhido.liability_percentage,
          liability_year: getYear(new Date()) - 1,
          plan_identifier:
            this.formFields.paymentMethod === 'bank_slip'
              ? `${this.$store.getters.planData.plan_id}-yearly`
              : this.$store.getters.planData.plan_id,
          plan_period:
            this.formFields.paymentMethod === CHECKOUT_CONST.PAYMENT.BANK_SLIP
              ? 'year'
              : 'month',
          pricing_items: pricingItems,
          organization_guid: this.formFields.organization_guid,
          contact_name: leadForm.lead_contact_name,
          contact_email: leadForm.lead_contact_email,
          contact_phone: leadForm.lead_contact_email,
          contact_company: leadForm.lead_contact_company_name,
          contact_fiesp: leadForm.lead_contact_fiesp_associate,
          plan_name: this.$store.getters.planData.plan_id,
        };

        if (
          this.formFields.paymentMethod === CHECKOUT_CONST.PAYMENT.BANK_SLIP
        ) {
          request = {
            ...request,
            plan_price_cents: this.planoEscolhido.year_plan.bank_slip
              .plan_price,
          };
        }

        /**
         * Se o Pagamento for em cartão de crédito
         */
        if (this.formFields.paymentMethod === CHECKOUT_CONST.PAYMENT.CARD) {
          const monthExpire = this.formFields.expireDate.split('/')[0];
          const yearExpire = this.formFields.expireDate.split('/')[1];

          /**
           * Crio um objeto Cartão de Crédito na IUGU
           */
          const creditCard = window.Iugu.CreditCard(
            this.formFields.cardnumber,
            monthExpire,
            yearExpire,
            this.formFields.firstName,
            this.formFields.lastName,
            this.formFields.cardcvv,
          );

          /**
           * Crio um token de pagamento na IUGU
           */
          const paymentToken = await promisify(window.Iugu.createPaymentToken)(
            creditCard,
          ).catch(res => {
            if (res.errors) {
              this.dialogShow = true;
              this.$router.replace({
                path: '/checkout',
                query: {
                  plan: this.$route.query.plan,
                  passo: 'pagamento-erro',
                },
              });
              console.error(res.errors);
              return true;
            }
            return res;
          });

          if (paymentToken === true) {
            this.paymentError = true;
            return false;
          }

          /**
           * Montagem da Requisição
           */
          request = {
            ...request,
            payment_token: paymentToken.id,
            cardholder_taxid: this.formFields.contact_cpf.replace(
              /\.|-|\//g,
              '',
            ),
            cardholder_name: `${this.formFields.firstName} ${this.formFields.lastName}`,
            contact_email: leadForm.lead_contact_email,
            charge_address_zipcode: this.formFields.address_zipcode.replace(
              '-',
              '',
            ),
            charge_address_street_name: this.formFields.address_street_name,
            charge_address_street_number: this.formFields.address_street_number,
            charge_address_additional_info: this.formFields
              .address_additional_info,
            charge_address_city: this.formFields.address_city,
            charge_address_state: this.formFields.address_state,
            installments: this.formFields.installment,
          };
        }

        const resOrder = await CheckoutProvider.postSubscribeCustomer(request);

        this.$store.commit('orderStatus', resOrder.data);

        this.$emit('openSucessoDrawer');

        window.open(resOrder.data.subscription.latest_invoice_url, '_blank');
        return resOrder.data;

        // this.$analytics('subscription_form', 'success');
        // this.handleChangeStep(1);
      } catch (err) {
        this.dialogShow = true;
        this.$router.replace({
          path: '/checkout',
          query: { plan: this.$route.query.plan, passo: 'pagamento-erro' },
        });
        console.error(err);
      }
    },
    async searchCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '');
      if (!UtilsProvider.validateCNPJ(cnpj)) return;

      try {
        const client = await CheckoutProvider.searchCNPJ(cnpj);
        if (!client.data) return;

        this.$store.commit('organization', client.data.organization);

        this.formFields.organization_name = client.data.organization.name;
        this.formFields.organization_guid = client.data.organization.guid;
        this.dialog = true;
      } catch (e) {
        this.dialog = true;
      }
    },
    async getOrganizationSizes() {
      this.organizationSizes = await CheckoutProvider.organizationSizes().then(
        res => {
          return res.data.data;
        },
      );
    },
    closeDrawer() {
      this.$emit('closePaymentDrawer');
    },
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

#app
  &.new-color
    .v-btn
      border-radius: 6px
      font-family: "metropolisbold" !important
      font-weight: 700 !important
      font-size: 18px
      text-transform: initial
      letter-spacing: 0px
      box-shadow: none
      &.cancel-btn
        border: 1px solid #EF3340
        background: transparent !important
        color: #EF3340 !important
        margin-right: 30px !important
      &.pay-btn
        border: 1px solid #26D07C
        background: #26D07C !important
        color: #003036 !important

.payment-drawer-wrapper
  position: fixed
  top: 0
  left: 0
  background: #ffffff
  height: 100%
  width: 100%
  padding-top: 80px
  z-index: 100
  outline: 0
  transition: transform 500ms ease-in-out
  transform: translateX(-110%)
  overflow-y: auto
  &.show
    transform: none
    transition: transform 500ms ease-in-out
  .close-btn
    position: absolute
    display: block
    top: 8%
    right: 4%
    color: #003036
    font-size: 20px
    font-family: "metropolisbold"
    font-weight: normal
    outline: none
    text-decoration: none
    z-index: 100
  ::v-deep
    .v-radio
      flex-flow: row-reverse
      padding: 16px 24px 16px 16px
      background: #FFFFFF
      border-left: 8px solid #CDCDD0
      box-shadow: 0px 4px 8px rgb(7 8 23 / 16%)
      border-radius: 8px
      transition: all 300ms ease-in-out
      &.v-item--active
        border-left: 8px solid #26D07C
        transition: all 300ms ease-in-out
      .v-input--selection-controls__input
        margin-right: 0
      .v-label
        margin-right: 15px
        .v-icon
          margin-right: 10px

.wrapper
  ::v-deep
    .title
      text-align: left !important
      font-size: 2rem !important
      font-weight: 600 !important
      @media screen and (max-width: 959px)
        padding-left: 12px
    .title + .row
      justify-content: flex-start !important
      .separator
        width: 50%
        height: 4px
        margin-top: 10px
        @media screen and (max-width: 959px)
          width: 80%
          height: 2px
          margin-left: 12px
</style>
